import { RgPipes } from "./index9.js";
import { PerfStopwatch } from "./index14.js";
import { pipeAddCornerCores } from "./index25.js";
import { pipeAddCorridors } from "./index27.js";
import { pipeAddFacade } from "./index28.js";
import { pipeAddMuscles } from "./index33.js";
import { pipeAddOpenings } from "./index48.js";
import { pipeTailor } from "./index70.js";
import { pipeAddPlots } from "./index80.js";
import { pipeAddPodium } from "./index83.js";
import { pipeAddPodiumEmptySpaces } from "./index84.js";
import { pipeAddPodiumGlazing } from "./index85.js";
import { pipeAddRoofAndParapet } from "./index86.js";
import { pipeAddTechSpaces } from "./index126.js";
import { pipeAggNmcs } from "./index169.js";
import { pipeCalcAnatomyCores } from "./index172.js";
import { pipeCalcAnatomyEntrances } from "./index174.js";
import { pipeClearZone } from "./index175.js";
import { pipeFilter } from "./index176.js";
import { pipeGeneratePolygons } from "./index177.js";
import { pipeRemoveEmptyBuildings } from "./index178.js";
import { pipeResize } from "./index179.js";
import { pipeSetBuildingIndexes } from "./index180.js";
import { pipeSetLevelData } from "./index181.js";
import { RG_TYPE, isInRange } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1, isPolygonClosed } from "@project-rouge/rg-three";
const RunPipeline = ({ obj, aggProps, buildingIds, from = RgPipes.Filter, to = RgPipes.SetBuildingIndexes, briefIndex, cache = [] }) => {
	aggProps = {
		...aggProps,
		zones: Object.fromEntries(Object.entries(aggProps.zones).filter((z) => !z[1].frozen)),
		dataset: {
			...aggProps.dataset,
			aggConfig: {
				...aggProps.dataset.aggConfig,
				face2FaceSeparation: aggProps.face2FaceSeparation ?? aggProps.dataset.aggConfig.face2FaceSeparation,
				face2SideSeparation: aggProps.face2SideSeparation ?? aggProps.dataset.aggConfig.face2SideSeparation
			}
		}
	};
	const stopwatch = { all: new PerfStopwatch() };
	if (getRgObjectsOfType$1(obj, RG_TYPE.Site).some((s) => !isPolygonClosed(s.data.polygon))) throw new Error("polygon needs to be closed");
	let mainThreads;
	let mainFrozenThreads;
	const techData = [];
	if (briefIndex !== void 0 && isInRange(RgPipes.Filter, from, to)) {
		var _RgPipes$Filter;
		const sw = stopwatch[_RgPipes$Filter = RgPipes.Filter] || (stopwatch[_RgPipes$Filter] = new PerfStopwatch());
		sw.resume();
		[, aggProps] = pipeFilter([obj, {
			aggProps,
			buildingIds,
			cache,
			briefIndex
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.ClearZone, from, to)) {
		var _RgPipes$ClearZone;
		const sw = stopwatch[_RgPipes$ClearZone = RgPipes.ClearZone] || (stopwatch[_RgPipes$ClearZone] = new PerfStopwatch());
		sw.resume();
		pipeClearZone([obj, { aggProps }]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddPlots, from, to)) {
		var _RgPipes$AddPlots;
		const sw = stopwatch[_RgPipes$AddPlots = RgPipes.AddPlots] || (stopwatch[_RgPipes$AddPlots] = new PerfStopwatch());
		sw.resume();
		const [, tailorData] = pipeAddPlots([obj, {
			aggProps,
			optimise: aggProps.optimisePlots
		}]);
		mainThreads = tailorData.mainThreads;
		mainFrozenThreads = tailorData.mainFrozenThreads;
		sw.pause();
	}
	if (isInRange(RgPipes.SkeletonTailorAnatomy, from, to)) {
		var _RgPipes$SkeletonTail;
		const sw = stopwatch[_RgPipes$SkeletonTail = RgPipes.SkeletonTailorAnatomy] || (stopwatch[_RgPipes$SkeletonTail] = new PerfStopwatch());
		sw.resume();
		if (mainThreads === void 0 || mainThreads.length === 0) {
			const [, tailorData] = pipeTailor([obj, { aggProps }]);
			mainThreads = tailorData.mainThreads;
			mainFrozenThreads = tailorData.mainFrozenThreads;
		}
		sw.pause();
	}
	if (isInRange(RgPipes.AddMuscles, from, to)) {
		var _RgPipes$AddMuscles;
		const sw = stopwatch[_RgPipes$AddMuscles = RgPipes.AddMuscles] || (stopwatch[_RgPipes$AddMuscles] = new PerfStopwatch());
		sw.resume();
		pipeAddMuscles([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.CalcAnatomyCores, from, to)) {
		var _RgPipes$CalcAnatomyC;
		const sw = stopwatch[_RgPipes$CalcAnatomyC = RgPipes.CalcAnatomyCores] || (stopwatch[_RgPipes$CalcAnatomyC] = new PerfStopwatch());
		sw.resume();
		pipeCalcAnatomyCores([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.CalcAnatomyEntrances, from, to)) {
		var _RgPipes$CalcAnatomyE;
		const sw = stopwatch[_RgPipes$CalcAnatomyE = RgPipes.CalcAnatomyEntrances] || (stopwatch[_RgPipes$CalcAnatomyE] = new PerfStopwatch());
		sw.resume();
		pipeCalcAnatomyEntrances([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AggNmcs, from, to)) {
		var _RgPipes$AggNmcs;
		const sw = stopwatch[_RgPipes$AggNmcs = RgPipes.AggNmcs] || (stopwatch[_RgPipes$AggNmcs] = new PerfStopwatch());
		sw.resume();
		pipeAggNmcs([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddCornerCores, from, to)) {
		var _RgPipes$AddCornerCor;
		const sw = stopwatch[_RgPipes$AddCornerCor = RgPipes.AddCornerCores] || (stopwatch[_RgPipes$AddCornerCor] = new PerfStopwatch());
		sw.resume();
		pipeAddCornerCores([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddCorridors, from, to)) {
		var _RgPipes$AddCorridors;
		const sw = stopwatch[_RgPipes$AddCorridors = RgPipes.AddCorridors] || (stopwatch[_RgPipes$AddCorridors] = new PerfStopwatch());
		sw.resume();
		pipeAddCorridors([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.SetLevelData, from, to)) {
		var _RgPipes$SetLevelData;
		const sw = stopwatch[_RgPipes$SetLevelData = RgPipes.SetLevelData] || (stopwatch[_RgPipes$SetLevelData] = new PerfStopwatch());
		sw.resume();
		pipeSetLevelData([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddPodium, from, to)) {
		var _RgPipes$AddPodium;
		const sw = stopwatch[_RgPipes$AddPodium = RgPipes.AddPodium] || (stopwatch[_RgPipes$AddPodium] = new PerfStopwatch());
		sw.resume();
		pipeAddPodium([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddTechSpaces, from, to)) {
		var _RgPipes$AddTechSpace;
		const sw = stopwatch[_RgPipes$AddTechSpace = RgPipes.AddTechSpaces] || (stopwatch[_RgPipes$AddTechSpace] = new PerfStopwatch());
		sw.resume();
		pipeAddTechSpaces([obj, {
			aggProps,
			buildingIds,
			techData
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.RemoveEmptyBuildings, from, to)) {
		var _RgPipes$RemoveEmptyB;
		const sw = stopwatch[_RgPipes$RemoveEmptyB = RgPipes.RemoveEmptyBuildings] || (stopwatch[_RgPipes$RemoveEmptyB] = new PerfStopwatch());
		sw.resume();
		pipeRemoveEmptyBuildings([obj, void 0]);
		sw.pause();
	}
	if (isInRange(RgPipes.Resize, from, to)) {
		var _RgPipes$Resize;
		const sw = stopwatch[_RgPipes$Resize = RgPipes.Resize] || (stopwatch[_RgPipes$Resize] = new PerfStopwatch());
		sw.resume();
		pipeResize([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddPodiumEmptySpaces, from, to)) {
		var _RgPipes$AddPodiumEmp;
		const sw = stopwatch[_RgPipes$AddPodiumEmp = RgPipes.AddPodiumEmptySpaces] || (stopwatch[_RgPipes$AddPodiumEmp] = new PerfStopwatch());
		sw.resume();
		pipeAddPodiumEmptySpaces([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddOpenings, from, to)) {
		var _RgPipes$AddOpenings;
		const sw = stopwatch[_RgPipes$AddOpenings = RgPipes.AddOpenings] || (stopwatch[_RgPipes$AddOpenings] = new PerfStopwatch());
		sw.resume();
		pipeAddOpenings([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddRoofAndParapet, from, to)) {
		var _RgPipes$AddRoofAndPa;
		const sw = stopwatch[_RgPipes$AddRoofAndPa = RgPipes.AddRoofAndParapet] || (stopwatch[_RgPipes$AddRoofAndPa] = new PerfStopwatch());
		sw.resume();
		pipeAddRoofAndParapet([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddFacade, from, to)) {
		var _RgPipes$AddFacade;
		const sw = stopwatch[_RgPipes$AddFacade = RgPipes.AddFacade] || (stopwatch[_RgPipes$AddFacade] = new PerfStopwatch());
		sw.resume();
		pipeAddFacade([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.AddPodiumGlazing, from, to)) {
		var _RgPipes$AddPodiumGla;
		const sw = stopwatch[_RgPipes$AddPodiumGla = RgPipes.AddPodiumGlazing] || (stopwatch[_RgPipes$AddPodiumGla] = new PerfStopwatch());
		sw.resume();
		pipeAddPodiumGlazing([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.GeneratePolygons, from, to)) {
		var _RgPipes$GeneratePoly;
		const sw = stopwatch[_RgPipes$GeneratePoly = RgPipes.GeneratePolygons] || (stopwatch[_RgPipes$GeneratePoly] = new PerfStopwatch());
		sw.resume();
		pipeGeneratePolygons([obj, {
			aggProps,
			buildingIds
		}]);
		sw.pause();
	}
	if (isInRange(RgPipes.SetBuildingIndexes, from, to)) {
		var _RgPipes$SetBuildingI;
		const sw = stopwatch[_RgPipes$SetBuildingI = RgPipes.SetBuildingIndexes] || (stopwatch[_RgPipes$SetBuildingI] = new PerfStopwatch());
		sw.resume();
		pipeSetBuildingIndexes([obj, void 0]);
		sw.pause();
	}
	stopwatch.all.pause();
	const duration = { ...Object.fromEntries(Object.entries(stopwatch).map(([pipe, sw]) => [pipe, sw.elapsed * .001])) };
	return {
		obj,
		cache,
		meta: {
			mainThreads,
			mainFrozenThreads,
			techData,
			duration
		}
	};
};
export { RunPipeline };

//# sourceMappingURL=index182.js.map